import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';

import StructureFolders from './StructureFolders.js';

const AboutPage = ({ clang, data, type }) => {
    const typeClass = type === 'records' ? 'folders__records' : '';

    return (
        <div className={`characters__about folders ${typeClass}`}>
          { data &&
            <div className="characters__container">
                <div className="characters__about-headings__container">
                    <h3 className="character-headings__form__title" dangerouslySetInnerHTML={{__html:data.acf.characteristic_title}}></h3>
                    <div className="character-headings__form__separator"></div>
                    <div className="character-headings__form__desc">
                        <span>{data.acf.characteristic_desc}</span>
                    </div>
                </div>

                {type === 'records' &&
                    <Link to={'/records/search?q=*&area=records'}
                     className="characters__about-btn"
                     title={lang[clang].characteristics.all_records}>
                        {lang[clang].characteristics.all_records}
                        <span className="characters__about-btn--img"></span>
                    </Link>}

                <div className="clearfix"></div>

                <StructureFolders data={data} type={type}/>

                {type === 'records' &&
                    <Link to={'/records/search?q=*&area=records'}
                     className="characters__about-btn"
                     title={lang[clang].characteristics.all_records}>
                        {lang[clang].characteristics.all_records}
                        <span className="characters__about-btn--img"></span>
                    </Link>}
            </div>
          }
        </div>
    );
};

AboutPage.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(AboutPage);



// WEBPACK FOOTER //
// ./src/components/characteristics/AboutPage.js